/* eslint-disable sort-keys */
const AppEnvironments = {
	local: {
		name: 'local',
		apiEndpoint: 'https://igienair-api.docker.localhost/',
		hostnames: ['localhost'],
	},
	dev: {
		name: 'dev',
		apiEndpoint: 'https://dev-igienair-api.staging.stonecode.io/',
		hostnames: [/https?:\/\/[^ ]*dev[^ ]*/gi],
	},
	demo: {
		name: 'demo',
		apiEndpoint: 'https://demo-igienair-api.staging.stonecode.io/',
		hostnames: [/https?:\/\/[^ ]*demo[^ ]*/gi],
	},
	preproduction: {
		name: 'preproduction',
		apiEndpoint: 'https://preproduction-igienair-api.staging.stonecode.io/',
		hostnames: [/https?:\/\/[^ ]*preproduction[^ ]*/gi],
	},
	production: {
		name: 'production',
		apiEndpoint: 'https://apiv2.qhs.fr/',
		hostnames: [/^(?!.*\b(dev|demo|preproduction|localhost)\b).*$/i],
	}
};

export default AppEnvironments;